export default {
  SET_JUMP_HOST_STATUS_DATA(state, params) {
    state.gridData = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/jumpHostStatus/jumpHostStatusMutation.js